var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedStoryPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5C7.41541 17.5 8.22083 17.6595 8.77832 17.8984C9.05786 18.0183 9.25198 18.1489 9.36914 18.2676C9.48407 18.3841 9.5 18.462 9.5 18.5C9.5 18.538 9.48407 18.6159 9.36914 18.7324C9.25198 18.8511 9.05786 18.9817 8.77832 19.1016C8.22083 19.3405 7.41541 19.5 6.5 19.5C5.58459 19.5 4.77917 19.3405 4.22168 19.1016C3.94214 18.9817 3.74802 18.8511 3.63086 18.7324C3.51593 18.6159 3.5 18.538 3.5 18.5C3.5 18.462 3.51593 18.3841 3.63086 18.2676C3.74802 18.1489 3.94214 18.0183 4.22168 17.8984C4.77917 17.6595 5.58459 17.5 6.5 17.5Z",
    stroke: "#FF00E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 0.50293C9.70855 0.410069 12.4593 2.9816 12.6631 6.20703L12.6748 6.52148C12.6742 7.10782 12.5789 7.68116 12.4229 8.22266L12.4219 8.22363C12.3091 8.61614 12.1574 8.97473 11.9648 9.33887L11.7627 9.68164L11.7607 9.68555L6.86816 18.085V18.0859C6.74734 18.2938 6.4315 18.2937 6.31055 18.0859V18.085L1.41797 9.68555L1.41602 9.68164L1.20703 9.3291C1.01714 8.96872 0.86856 8.61318 0.755859 8.22266L0.751953 8.21094C0.562219 7.60791 0.483476 6.96084 0.50293 6.28418C0.618078 3.16947 3.20525 0.599385 6.37305 0.50293Z",
    fill: "#FF00E1",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedStoryPin);
export default __webpack_public_path__ + "static/media/HighlightedStoryPin.03ec834f10ac3025f9708751c5aec3e2.svg";
export { ForwardRef as ReactComponent };